<template>
  <div class="card p-4 shadow-sm">
    <div class="container-fluid my-4">
      <h3 class="text-center mb-4">Cambiar Habitación</h3>

      <!-- Información general de la reserva -->
      <div class="row mb-3">
        <div class="col-md-6">
          <label class="form-label">Código de Reserva</label>
          <input
            type="text"
            class="form-control"
            :value="'R00' + reserva?.IdReserva"
            readonly
          />
        </div>
        <div class="col-md-6">
          <label class="form-label">Cliente</label>
          <input
            type="text"
            class="form-control"
            :value="reserva?.huesped?.Nombre + ' ' + reserva?.huesped?.Apellido"
            readonly
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <label class="form-label">Fecha de Llegada</label>
          <input
            type="text"
            class="form-control"
            :value="formatearFecha(reserva?.FechaLlegada)"
            readonly
          />
        </div>
        <div class="col-md-6">
          <label class="form-label">Fecha de Salida</label>
          <input
            type="text"
            class="form-control"
            :value="formatearFecha(reserva?.FechaSalida)"
            readonly
          />
        </div>
      </div>

      <hr class="my-4" />

      <!-- Listado de habitaciones reservadas -->
      <div
        v-for="(resHab, index) in reserva?.habitaciones_reservadas"
        :key="resHab.IdReservaHabitacion"
        class="mb-4 border rounded p-3"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <strong>Habitación #{{ resHab.habitacion?.Numero }}</strong> -
            {{ resHab.habitacion?.tipo?.Nombre }}
          </div>
          <button
            class="btn btn-sm btn-outline-primary"
            @click="cargarDisponibles(resHab.IdReservaHabitacion, index)"
          >
            Cambiar Habitación
          </button>
        </div>

        <div v-if="resHab.habitacionesDisponibles">
          <div class="mt-3">
            <label class="form-label">Seleccionar nueva habitación</label>
            <select
              class="form-select"
              v-model="resHab.nuevaHabitacionSeleccionada"
              @change="verificarConflicto(resHab)"
            >
              <option value="" disabled>Seleccione una opción</option>
              <option
                v-for="h in resHab.habitacionesDisponibles"
                :key="h.IdHabitacion"
                :value="h.IdHabitacion"
              >
                #{{ h.Numero }} - {{ h.tipo?.Nombre }} ({{
                  h.estado?.Estado || "Disponible"
                }}){{ h.tieneConflicto ? " ⚠ Reservada en esas fechas" : "" }}
              </option>
            </select>
            <div
              v-if="resHab.alertaConflicto"
              class="alert alert-warning mt-2 py-2 mb-0"
              role="alert"
            >
              <i class="bi bi-exclamation-triangle-fill me-1"></i>
              Esta habitación tiene otra reserva en las mismas fechas. Confirme
              solo si es un traslado autorizado.
            </div>
          </div>
          <div class="mt-3">
            <label class="form-label">Motivo del cambio</label>
            <textarea
              class="form-control"
              v-model="resHab.motivo"
              placeholder="Escriba el motivo del cambio de habitación"
              rows="2"
            ></textarea>
          </div>

          <div class="text-end mt-2">
            <button
              class="btn btn-success"
              @click="confirmarCambio(resHab)"
              :disabled="resHab.procesando"
            >
              <span v-if="resHab.procesando" class="spinner-border spinner-border-sm me-1"></span>
              {{ resHab.procesando ? 'Procesando...' : 'Confirmar Cambio' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Toast -->
    <div
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1055"
    >
      <div
        v-if="mostrarToast"
        class="toast show text-white"
        :class="toastColor"
      >
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i> {{ alerta.mensaje }}
          </div>
          <button
            type="button"
            class="btn-close btn-close-white me-2 m-auto"
            @click="cerrarToast"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/config/axios";

export default {
  name: "CambiarHabitacion",
  data() {
    return {
      reserva: null,
      alerta: { mensaje: "", tipo: "success" },
      mostrarToast: false,
    };
  },
  mounted() {
    const idReserva = this.$route.params.id;
    this.obtenerReserva(idReserva);
  },
  methods: {
    async obtenerReserva(id) {
      try {
        const res = await axios.get(`/reservas/${id}`);
        this.reserva = res.data.reserva;

        // Agregar campos adicionales a cada habitación reservada
        this.reserva.habitaciones_reservadas.forEach((h) => {
          h.habitacionesDisponibles = null;
          h.nuevaHabitacionSeleccionada = "";
          h.motivo = "";
          h.alertaConflicto = false;
          h.procesando = false;
        });
      } catch (error) {
        this.mostrarToastMensaje(
          "Error al obtener información de la reserva",
          "danger",
        );
        console.error(error);
      }
    },
    async cargarDisponibles(idReservaHabitacion, index) {
      try {
        const res = await axios.get(
          `/reserva-habitacion/${idReservaHabitacion}/habitaciones-disponibles`,
        );
        this.reserva.habitaciones_reservadas[index].habitacionesDisponibles =
          res.data.habitaciones;
        this.reserva.habitaciones_reservadas[
          index
        ].nuevaHabitacionSeleccionada = "";
        this.reserva.habitaciones_reservadas[index].alertaConflicto = false;
      } catch (error) {
        this.mostrarToastMensaje(
          "Error al cargar habitaciones disponibles",
          "danger",
        );
        console.error(error);
      }
    },
    verificarConflicto(resHab) {
      const seleccionada = resHab.habitacionesDisponibles?.find(
        (h) => h.IdHabitacion === resHab.nuevaHabitacionSeleccionada,
      );
      resHab.alertaConflicto = seleccionada?.tieneConflicto ?? false;
    },
    async confirmarCambio(resHab) {
      if (resHab.procesando) return; // Prevenir doble click
      try {
        if (!resHab.nuevaHabitacionSeleccionada) {
          this.mostrarToastMensaje(
            "Debe seleccionar una nueva habitación",
            "warning",
          );
          return;
        }

        if (!resHab.motivo || resHab.motivo.trim() === "") {
          this.mostrarToastMensaje(
            "Debe ingresar el motivo del cambio",
            "warning",
          );
          return;
        }

        resHab.procesando = true;

        await axios.put(
          `/reserva-habitacion/${resHab.IdReservaHabitacion}/cambiar`,
          {
            idHabitacionNueva: resHab.nuevaHabitacionSeleccionada,
            motivo: resHab.motivo,
          },
        );

        this.mostrarToastMensaje(
          "Habitación cambiada correctamente",
          "success",
        );
        resHab.habitacion.Numero = resHab.nuevaHabitacionSeleccionada;
        resHab.habitacionesDisponibles = null;
        resHab.nuevaHabitacionSeleccionada = "";
        resHab.motivo = "";
        resHab.alertaConflicto = false;
        this.obtenerReserva(this.reserva.IdReserva);
      } catch (error) {
        const msg =
          error.response?.data?.mensaje || "Error al cambiar habitación";
        this.mostrarToastMensaje(msg, "danger");
        console.error(error);
      } finally {
        resHab.procesando = false;
      }
    },
    formatearFecha(fecha) {
      const d = new Date(fecha);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0",
      )}-${String(d.getDate()).padStart(2, "0")}`;
    },
    mostrarToastMensaje(mensaje, tipo = "success") {
      this.alerta.mensaje = mensaje;
      this.alerta.tipo = tipo;
      this.mostrarToast = true;
      setTimeout(() => (this.mostrarToast = false), 3000);
    },
    cerrarToast() {
      this.mostrarToast = false;
    },
  },
  computed: {
    toastColor() {
      return (
        {
          success: "bg-success",
          danger: "bg-danger",
          warning: "bg-warning text-dark",
          info: "bg-info text-dark",
        }[this.alerta.tipo] || "bg-primary"
      );
    },
    iconoToast() {
      return (
        {
          success: "bi bi-check-circle-fill",
          danger: "bi bi-x-circle-fill",
          warning: "bi bi-exclamation-triangle-fill",
          info: "bi bi-info-circle-fill",
        }[this.alerta.tipo] || "bi bi-info-circle-fill"
      );
    },
  },
};
</script>

<style scoped>
input[readonly] {
  background-color: #f5f5f5;
}
</style>
